import React, { useState, useEffect } from 'react';

export default function Proyeccion({ ingresoBrutoMensual, clientesActivos }) {
  const [servicios, setServicios] = useState(() => {
    try { const s = localStorage.getItem('proyeccion_servicios'); return s ? JSON.parse(s) : [
      { id: 1, nombre: 'Supabase Pro', categoria: 'infraestructura', tipo: 'fijo', costo: 437, activo: true },
      { id: 2, nombre: 'Vercel', categoria: 'infraestructura', tipo: 'fijo', costo: 0, activo: true },
      { id: 3, nombre: 'Dominio', categoria: 'infraestructura', tipo: 'fijo', costo: 26, activo: true },
      { id: 4, nombre: 'WhatsApp API', categoria: 'infraestructura', tipo: 'variable', costo: 175, activo: false },
    ]; } catch { return [
      { id: 1, nombre: 'Supabase Pro', categoria: 'infraestructura', tipo: 'fijo', costo: 437, activo: true },
      { id: 2, nombre: 'Vercel', categoria: 'infraestructura', tipo: 'fijo', costo: 0, activo: true },
      { id: 3, nombre: 'Dominio', categoria: 'infraestructura', tipo: 'fijo', costo: 26, activo: true },
      { id: 4, nombre: 'WhatsApp API', categoria: 'infraestructura', tipo: 'variable', costo: 175, activo: false },
    ]; }
  });
  const [showNuevoServicio, setShowNuevoServicio] = useState(false);
  const [nuevoServicio, setNuevoServicio] = useState({ nombre: '', categoria: 'infraestructura', tipo: 'fijo', costo: '', comentario: '' });
  const [planesProyectados, setPlanesProyectados] = useState([
    { plan: 'Starter', clientes: 0, precio: 9999 },
    { plan: 'Business', clientes: 5, precio: 14999 },
    { plan: 'A Medida', clientes: 0, precio: 25000 },
  ]);
  const [efectivo, setEfectivo] = useState('');
  const [ingresosExtra, setIngresosExtra] = useState(() => {
    try { const s = localStorage.getItem('proyeccion_ingresos'); return s ? JSON.parse(s) : []; } catch { return []; }
  });
  const [showNuevoIngreso, setShowNuevoIngreso] = useState(false);
  const [nuevoIngreso, setNuevoIngreso] = useState({ nombre: '', monto: '', tipo: 'fijo' });
  const [alertaMargen, setAlertaMargen] = useState(70);
  const [alertaCosto, setAlertaCosto] = useState(30);
  useEffect(() => { localStorage.setItem('proyeccion_servicios', JSON.stringify(servicios)); }, [servicios]);
  useEffect(() => { localStorage.setItem('proyeccion_ingresos', JSON.stringify(ingresosExtra)); }, [ingresosExtra]);

  const categorias = ['infraestructura', 'nomina', 'marketing', 'impuestos', 'otro'];
  const calcularCostoNomina = (salarioNeto) => {
    // IMSS cuotas patronales aproximadas: ~30% sobre salario
    const imss = salarioNeto * 0.30;
    // ISR retencion aproximada: ~10% promedio para salarios bajos/medios
    const isr = salarioNeto * 0.10;
    // Infonavit: 5% sobre salario
    const infonavit = salarioNeto * 0.05;
    const total = salarioNeto + imss + infonavit;
    return { imss, isr, infonavit, total };
  };
  const categoriaColor = { infraestructura: '#3b82f6', nomina: '#8b5cf6', marketing: '#f59e0b', impuestos: '#ef4444', otro: '#6b7280' };

  const costosActivos = servicios.filter(s => s.activo);
  const costosFijos = costosActivos.filter(s => s.tipo === 'fijo').reduce((a, s) => a + s.costo, 0);
  const costosVariablesPorCliente = costosActivos.filter(s => s.tipo === 'variable').reduce((a, s) => a + s.costo, 0);
  const costoTotalMensual = costosFijos + costosVariablesPorCliente * clientesActivos;
  const ingresoExtraMensual = ingresosExtra.filter(i => i.activo).reduce((a, i) => a + (i.tipo === 'fijo' ? parseFloat(i.monto) : parseFloat(i.monto) * clientesActivos), 0);
  const ingresoTotalMensual = ingresoBrutoMensual + ingresoExtraMensual;
  const margenActual = ingresoTotalMensual > 0 ? ((ingresoTotalMensual - costoTotalMensual) / ingresoTotalMensual * 100).toFixed(1) : 0;

  const clientesExtra = planesProyectados.reduce((a, p) => a + p.clientes, 0);
  const ingresoProyectado = ingresoTotalMensual + planesProyectados.reduce((a, p) => a + p.clientes * p.precio, 0);
  const costoProyectado = costosFijos + costosVariablesPorCliente * (clientesActivos + clientesExtra);
  const margenProyectado = ingresoProyectado > 0 ? ((ingresoProyectado - costoProyectado) / ingresoProyectado * 100).toFixed(1) : 0;
const utilidadBruta = ingresoProyectado - costoProyectado;
  const isrProyectado = utilidadBruta > 0 ? utilidadBruta * 0.30 : 0;
  const utilidadNeta = utilidadBruta - isrProyectado;
  const margenNeto = ingresoProyectado > 0 ? (utilidadNeta / ingresoProyectado * 100).toFixed(1) : 0;

  const utilidadBrutaActual = ingresoTotalMensual - costoTotalMensual;
  const isrActual = utilidadBrutaActual > 0 ? utilidadBrutaActual * 0.30 : 0;
  const utilidadNetaActual = utilidadBrutaActual - isrActual;
  const margenNetoActual = ingresoTotalMensual > 0 ? (utilidadNetaActual / ingresoTotalMensual * 100).toFixed(1) : 0;
  const puntoEquilibrio = costosVariablesPorCliente > 0 ? Math.ceil(costosFijos / (14999 - costosVariablesPorCliente)) : Math.ceil(costosFijos / 14999) || 1;
  const runwayMeses = efectivo && costoTotalMensual > 0 ? (parseFloat(efectivo) / costoTotalMensual).toFixed(1) : null;

  const costosPorCategoria = categorias.map(cat => ({
    cat, total: costosActivos.filter(s => s.categoria === cat).reduce((a, s) => a + (s.tipo === 'fijo' ? s.costo : s.costo * clientesActivos), 0)
  })).filter(c => c.total > 0);

  const alertas = [];
  if (ingresoTotalMensual > 0 && parseFloat(margenActual) < alertaMargen) alertas.push({ msg: `Margen actual ${margenActual}% está por debajo del umbral de ${alertaMargen}%`, color: '#ef4444' });
  costosActivos.forEach(s => {
    const costoReal = s.tipo === 'fijo' ? s.costo : s.costo * clientesActivos;
    if (ingresoBrutoMensual > 0 && (costoReal / ingresoBrutoMensual * 100) > alertaCosto) {
      alertas.push({ msg: `"${s.nombre}" representa ${(costoReal / ingresoBrutoMensual * 100).toFixed(1)}% del ingreso`, color: '#f59e0b' });
    }
  });

  const s = {
    input: { width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '8px 10px', color: '#e8eaf0', fontSize: '13px', boxSizing: 'border-box' },
    label: { fontSize: '11px', color: '#6b7280', display: 'block', marginBottom: '4px' },
    btnGreen: { background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
    btnOutline: { background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer' },
  };

  return (
    <div>
      <div style={{ fontSize: '18px', fontWeight: '700', color: '#fff', marginBottom: '20px' }}>Proyección Financiera</div>

      {alertas.length > 0 && (
        <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {alertas.map((a, i) => (
            <div key={i} style={{ background: `${a.color}18`, border: `1px solid ${a.color}40`, borderRadius: '8px', padding: '10px 16px', fontSize: '13px', color: a.color }}>
              ⚠️ {a.msg}
            </div>
          ))}
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px' }}>
          <div style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '16px' }}>Escenario Actual</div>
          {[
            { label: 'Clientes activos', value: clientesActivos, color: '#e8eaf0' },
            { label: 'Ingreso suscripciones', value: `$${ingresoBrutoMensual.toLocaleString('es-MX')}`, color: '#00e5a0' },
            { label: 'Ingresos adicionales', value: `$${ingresoExtraMensual.toLocaleString('es-MX')}`, color: '#3b82f6' },
            { label: 'Ingreso total', value: `$${ingresoTotalMensual.toLocaleString('es-MX')}`, color: '#00e5a0' },
            { label: 'Costos fijos', value: `$${costosFijos.toLocaleString('es-MX')}`, color: '#ef4444' },
            { label: 'Costos variables', value: `$${(costosVariablesPorCliente * clientesActivos).toLocaleString('es-MX')}`, color: '#f59e0b' },
            { label: 'Costo total', value: `$${costoTotalMensual.toLocaleString('es-MX')}`, color: '#ef4444' },
            { label: 'Margen bruto', value: `${margenActual}%`, color: parseFloat(margenActual) < alertaMargen ? '#ef4444' : '#00e5a0' },
            { label: 'Utilidad bruta', value: `$${utilidadBrutaActual.toLocaleString('es-MX', {maximumFractionDigits:0})}`, color: utilidadBrutaActual > 0 ? '#e8eaf0' : '#ef4444' },
            { label: 'ISR estimado (30%)', value: `-$${isrActual.toLocaleString('es-MX', {maximumFractionDigits:0})}`, color: '#ef4444' },
            { label: 'Utilidad neta', value: `$${utilidadNetaActual.toLocaleString('es-MX', {maximumFractionDigits:0})}`, color: utilidadNetaActual > 0 ? '#00e5a0' : '#ef4444' },
            { label: 'Margen neto', value: `${margenNetoActual}%`, color: parseFloat(margenNetoActual) < alertaMargen ? '#ef4444' : '#00e5a0' },
          ].map((k, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #222730' }}>
              <span style={{ fontSize: '13px', color: '#9ca3af' }}>{k.label}</span>
              <span style={{ fontSize: '13px', fontWeight: '700', color: k.color }}>{k.value}</span>
            </div>
          ))}
        </div>

        <div style={{ background: '#111318', border: '1px solid rgba(0,229,160,0.2)', borderRadius: '10px', padding: '24px' }}>
          <div style={{ marginBottom: '16px' }}>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#00e5a0', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '12px' }}>Escenario Proyectado</div>
              <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '8px' }}>
                <thead>
                  <tr>
                    {['Plan', 'Clientes nuevos', 'Precio/cliente (MXN)', 'Ingreso adicional'].map(h => (
                      <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', color: '#6b7280', padding: '6px 8px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {planesProyectados.map((p, i) => (
                    <tr key={i}>
                      <td style={{ padding: '8px', fontSize: '13px', color: '#e8eaf0', fontWeight: '600' }}>{p.plan}</td>
                      <td style={{ padding: '8px' }}>
                        <input type="number" value={p.clientes} onChange={e => setPlanesProyectados(planesProyectados.map((x, j) => j === i ? { ...x, clientes: parseInt(e.target.value) || 0 } : x))}
                          style={{ width: '80px', background: '#181c24', border: '1px solid #00e5a0', borderRadius: '6px', padding: '4px 8px', color: '#00e5a0', fontSize: '13px', fontWeight: '700', textAlign: 'center' }} />
                      </td>
                      <td style={{ padding: '8px' }}>
                        <input type="number" value={p.precio} onChange={e => setPlanesProyectados(planesProyectados.map((x, j) => j === i ? { ...x, precio: parseFloat(e.target.value) || 0 } : x))}
                          style={{ width: '120px', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '4px 8px', color: '#e8eaf0', fontSize: '13px' }} />
                      </td>
                      <td style={{ padding: '8px', fontSize: '13px', color: '#00e5a0', fontWeight: '600' }}>
                        ${(p.clientes * p.precio).toLocaleString('es-MX')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          {[
            { label: 'Clientes proyectados', value: clientesActivos + clientesExtra, color: '#e8eaf0' },
            { label: 'Ingreso proyectado', value: `$${ingresoProyectado.toLocaleString('es-MX')}`, color: '#00e5a0' },
            { label: 'Costos fijos', value: `$${costosFijos.toLocaleString('es-MX')}`, color: '#ef4444' },
            { label: 'Costos variables', value: `$${(costosVariablesPorCliente * (clientesActivos + clientesExtra)).toLocaleString('es-MX')}`, color: '#f59e0b' },
            { label: 'Costo total', value: `$${costoProyectado.toLocaleString('es-MX')}`, color: '#ef4444' },
            { label: 'Margen bruto', value: `${margenProyectado}%`, color: parseFloat(margenProyectado) < alertaMargen ? '#ef4444' : '#00e5a0' },
            { label: 'Utilidad bruta', value: `$${utilidadBruta.toLocaleString('es-MX', {maximumFractionDigits:0})}`, color: utilidadBruta > 0 ? '#e8eaf0' : '#ef4444' },
            { label: 'ISR estimado (30%)', value: `-$${isrProyectado.toLocaleString('es-MX', {maximumFractionDigits:0})}`, color: '#ef4444' },
            { label: 'Utilidad neta', value: `$${utilidadNeta.toLocaleString('es-MX', {maximumFractionDigits:0})}`, color: utilidadNeta > 0 ? '#00e5a0' : '#ef4444' },
            { label: 'Margen neto', value: `${margenNeto}%`, color: parseFloat(margenNeto) < alertaMargen ? '#ef4444' : '#00e5a0' },
          ].map((k, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #222730' }}>
              <span style={{ fontSize: '13px', color: '#9ca3af' }}>{k.label}</span>
              <span style={{ fontSize: '13px', fontWeight: '700', color: k.color }}>{k.value}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '24px' }}>
        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: '2px solid #3b82f6' }}>
          <div style={{ fontSize: '11px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '8px' }}>Punto de equilibrio</div>
          <div style={{ fontSize: '28px', fontWeight: '700', color: '#3b82f6', marginBottom: '4px' }}>{puntoEquilibrio} clientes</div>
          <div style={{ fontSize: '11px', color: '#6b7280' }}>Mínimo para cubrir costos fijos</div>
        </div>
        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: '2px solid #8b5cf6' }}>
          <div style={{ fontSize: '11px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '8px' }}>Runway</div>
          <div style={{ fontSize: '28px', fontWeight: '700', color: '#8b5cf6', marginBottom: '8px' }}>{runwayMeses ? `${runwayMeses} meses` : '—'}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '11px', color: '#6b7280', whiteSpace: 'nowrap' }}>Efectivo MXN:</span>
            <input type="number" value={efectivo} onChange={e => setEfectivo(e.target.value)}
              placeholder="0" style={{ flex: 1, background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '4px 8px', color: '#e8eaf0', fontSize: '12px' }} />
          </div>
        </div>
        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: '2px solid #f59e0b' }}>
          <div style={{ fontSize: '11px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '12px' }}>Umbrales de alerta</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div>
              <label style={s.label}>Margen mínimo (%)</label>
              <input type="number" value={alertaMargen} onChange={e => setAlertaMargen(parseFloat(e.target.value))} style={s.input} />
            </div>
            <div>
              <label style={s.label}>Costo máx por servicio (%)</label>
              <input type="number" value={alertaCosto} onChange={e => setAlertaCosto(parseFloat(e.target.value))} style={s.input} />
            </div>
          </div>
        </div>
      </div>

<div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden', marginBottom: '24px' }}>
  <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <div>
      <span style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>Ingresos Adicionales</span>
      <span style={{ fontSize: '12px', color: '#00e5a0', marginLeft: '12px', fontWeight: '700' }}>+${ingresoExtraMensual.toLocaleString('es-MX')}/mes</span>
    </div>
    <button onClick={() => setShowNuevoIngreso(true)} style={{ background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>+ Agregar</button>
  </div>
  {showNuevoIngreso && (
    <div style={{ padding: '16px 20px', borderBottom: '1px solid #222730', background: 'rgba(0,229,160,0.03)' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '12px' }}>
        <div><label style={s.label}>Nombre</label><input value={nuevoIngreso.nombre} onChange={e => setNuevoIngreso({...nuevoIngreso, nombre: e.target.value})} placeholder="Ej: Addon WhatsApp" style={s.input} /></div>
        <div><label style={s.label}>Tipo</label>
          <select value={nuevoIngreso.tipo} onChange={e => setNuevoIngreso({...nuevoIngreso, tipo: e.target.value})} style={s.input}>
            <option value="fijo">Fijo mensual</option>
            <option value="variable">Variable x cliente</option>
          </select>
        </div>
        <div><label style={s.label}>Monto MXN/mes</label><input type="number" value={nuevoIngreso.monto} onChange={e => setNuevoIngreso({...nuevoIngreso, monto: e.target.value})} style={s.input} /></div>
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button onClick={() => { if (!nuevoIngreso.nombre || !nuevoIngreso.monto) return; setIngresosExtra([...ingresosExtra, { id: Date.now(), ...nuevoIngreso, monto: parseFloat(nuevoIngreso.monto), activo: true }]); setNuevoIngreso({ nombre: '', monto: '', tipo: 'fijo' }); setShowNuevoIngreso(false); }} style={s.btnGreen}>Guardar</button>
        <button onClick={() => setShowNuevoIngreso(false)} style={s.btnOutline}>Cancelar</button>
      </div>
    </div>
  )}
  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    <thead>
      <tr>{['Nombre', 'Tipo', 'Monto/mes', 'Total real', 'Activo', ''].map(h => (
        <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
      ))}</tr>
    </thead>
    <tbody>
      {ingresosExtra.map((ing, i) => (
        <tr key={ing.id} style={{ background: i % 2 === 0 ? 'transparent' : '#0d1117', opacity: ing.activo ? 1 : 0.5 }}>
          <td style={{ padding: '12px 16px', fontSize: '13px', color: '#e8eaf0', fontWeight: '500' }}>{ing.nombre}</td>
          <td style={{ padding: '12px 16px', fontSize: '12px', color: '#9ca3af' }}>{ing.tipo === 'fijo' ? 'Fijo' : 'Variable x cliente'}</td>
          <td style={{ padding: '12px 16px', fontSize: '13px', color: '#e8eaf0' }}>${parseFloat(ing.monto).toLocaleString('es-MX')}</td>
          <td style={{ padding: '12px 16px', fontSize: '13px', color: '#00e5a0', fontWeight: '600' }}>${(ing.tipo === 'fijo' ? parseFloat(ing.monto) : parseFloat(ing.monto) * clientesActivos).toLocaleString('es-MX')}</td>
          <td style={{ padding: '12px 16px' }}>
            <div onClick={() => setIngresosExtra(ingresosExtra.map(x => x.id === ing.id ? { ...x, activo: !x.activo } : x))}
              style={{ width: '36px', height: '20px', borderRadius: '10px', background: ing.activo ? '#00e5a0' : '#222730', cursor: 'pointer', position: 'relative' }}>
              <div style={{ width: '14px', height: '14px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '3px', left: ing.activo ? '19px' : '3px', transition: 'left 0.2s' }}></div>
            </div>
          </td>
          <td style={{ padding: '12px 16px' }}>
            <button onClick={() => setIngresosExtra(ingresosExtra.filter(x => x.id !== ing.id))} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '12px' }}>Eliminar</button>
          </td>
        </tr>
      ))}
      {ingresosExtra.length === 0 && !showNuevoIngreso && (
        <tr><td colSpan="6" style={{ padding: '24px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin ingresos adicionales registrados</td></tr>
      )}
    </tbody>
  </table>
</div>
      {costosPorCategoria.length > 0 && (
        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px', marginBottom: '24px' }}>
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#fff', marginBottom: '16px' }}>Costos por Categoría</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {costosPorCategoria.map((c, i) => (
              <div key={i}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ fontSize: '12px', color: '#9ca3af', textTransform: 'capitalize' }}>{c.cat}</span>
                  <span style={{ fontSize: '12px', fontWeight: '700', color: categoriaColor[c.cat] }}>${c.total.toLocaleString('es-MX')}</span>
                </div>
                <div style={{ height: '6px', background: '#222730', borderRadius: '3px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: `${costoTotalMensual > 0 ? (c.total / costoTotalMensual * 100) : 0}%`, background: categoriaColor[c.cat], borderRadius: '3px' }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <NominaCalculadora calcularCostoNomina={calcularCostoNomina} s={s} />
      <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>Servicios y Costos</span>
          <button onClick={() => setShowNuevoServicio(true)} style={{ background: 'rgba(0,229,160,0.1)', border: '1px solid rgba(0,229,160,0.2)', color: '#00e5a0', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>+ Agregar</button>
        </div>
        {showNuevoServicio && (
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #222730', background: 'rgba(0,229,160,0.03)' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '12px' }}>
              <div><label style={s.label}>Nombre</label><input value={nuevoServicio.nombre} onChange={e => setNuevoServicio({...nuevoServicio, nombre: e.target.value})} style={s.input} /></div>
              <div><label style={s.label}>Categoría</label>
                <select value={nuevoServicio.categoria} onChange={e => setNuevoServicio({...nuevoServicio, categoria: e.target.value})} style={s.input}>
                  {categorias.map(c => <option key={c} value={c}>{c}</option>)}
                </select></div>
              <div><label style={s.label}>Tipo</label>
                <select value={nuevoServicio.tipo} onChange={e => setNuevoServicio({...nuevoServicio, tipo: e.target.value})} style={s.input}>
                  <option value="fijo">Fijo</option>
                  <option value="variable">Variable x cliente</option>
                </select></div>
              <div><label style={s.label}>Costo MXN/mes</label><input type="number" value={nuevoServicio.costo} onChange={e => setNuevoServicio({...nuevoServicio, costo: e.target.value})} style={s.input} /></div>
              <div style={{ gridColumn: '1 / -1' }}><label style={s.label}>Comentario</label><input value={nuevoServicio.comentario || ''} onChange={e => setNuevoServicio({...nuevoServicio, comentario: e.target.value})} placeholder="Ej: incluye 500 folios/mes, precio sin IVA..." style={s.input} /></div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => { if (!nuevoServicio.nombre) return; setServicios([...servicios, { id: Date.now(), ...nuevoServicio, costo: parseFloat(nuevoServicio.costo) || 0, activo: true }]); setNuevoServicio({ nombre: '', categoria: 'infraestructura', tipo: 'fijo', costo: '', comentario: '' }); setShowNuevoServicio(false); }} style={s.btnGreen}>Guardar</button>
              <button onClick={() => setShowNuevoServicio(false)} style={s.btnOutline}>Cancelar</button>
            </div>
          </div>
        )}
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>{['Servicio', 'Categoría', 'Tipo', 'Costo/mes', 'Comentario', 'Activo', ''].map(h => (
              <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', padding: '12px 16px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {servicios.map((sv, i) => (
              <tr key={sv.id} style={{ background: i % 2 === 0 ? 'transparent' : '#0d1117', opacity: sv.activo ? 1 : 0.5 }}>
                <td style={{ padding: '12px 16px', fontSize: '13px', color: '#e8eaf0', fontWeight: '500' }}>{sv.nombre}</td>
                <td style={{ padding: '12px 16px' }}><span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: `${categoriaColor[sv.categoria]}18`, color: categoriaColor[sv.categoria], fontWeight: '600', textTransform: 'capitalize' }}>{sv.categoria}</span></td>
                <td style={{ padding: '12px 16px', fontSize: '12px', color: '#9ca3af' }}>{sv.tipo === 'fijo' ? 'Fijo' : 'Variable x cliente'}</td>
                <td style={{ padding: '12px 16px', fontSize: '13px', color: '#e8eaf0' }}>${sv.costo.toLocaleString('es-MX')}</td>
                <td style={{ padding: '12px 16px', fontSize: '12px', color: '#6b7280', fontStyle: 'italic' }}>{sv.comentario || '—'}</td>
                <td style={{ padding: '12px 16px' }}>
                  <div onClick={() => setServicios(servicios.map(x => x.id === sv.id ? { ...x, activo: !x.activo } : x))}
                    style={{ width: '36px', height: '20px', borderRadius: '10px', background: sv.activo ? '#00e5a0' : '#222730', cursor: 'pointer', position: 'relative' }}>
                    <div style={{ width: '14px', height: '14px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '3px', left: sv.activo ? '19px' : '3px', transition: 'left 0.2s' }}></div>
                  </div>
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <button onClick={() => setServicios(servicios.filter(x => x.id !== sv.id))} style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '12px' }}>Eliminar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
  function NominaCalculadora({ calcularCostoNomina, s }) {
  const [salario, setSalario] = React.useState('');
  const [mostrar, setMostrar] = React.useState(false);
  const resultado = salario ? calcularCostoNomina(parseFloat(salario)) : null;

  return (
    <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', marginBottom: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: mostrar ? '16px' : '0' }}>
        <div>
          <span style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>Calculadora de Nómina</span>
          <span style={{ fontSize: '12px', color: '#6b7280', marginLeft: '12px' }}>IMSS + Infonavit + ISR estimado</span>
        </div>
        <button onClick={() => setMostrar(!mostrar)} style={{ background: 'rgba(139,92,246,0.1)', border: '1px solid rgba(139,92,246,0.2)', color: '#8b5cf6', borderRadius: '6px', padding: '4px 10px', fontSize: '11px', cursor: 'pointer', fontWeight: '600' }}>{mostrar ? 'Ocultar' : 'Calcular'}</button>
      </div>
      {mostrar && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div>
              <label style={s.label}>Salario neto mensual (MXN)</label>
              <input type="number" value={salario} onChange={e => setSalario(e.target.value)} placeholder="Ej: 10000" style={s.input} />
              <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>Lo que el empleado recibe en mano</div>
            </div>
            {resultado && (
              <div style={{ background: '#0d1117', borderRadius: '8px', padding: '16px' }}>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>Costo real para la empresa</div>
                {[
                  { label: 'Salario neto', value: parseFloat(salario), color: '#e8eaf0' },
                  { label: 'IMSS patronal (~30%)', value: resultado.imss, color: '#ef4444' },
                  { label: 'Infonavit (5%)', value: resultado.infonavit, color: '#f59e0b' },
                  { label: 'ISR retenido (~10%)', value: resultado.isr, color: '#6b7280', nota: 'Lo retiene el empleado' },
                  { label: 'Costo total empresa', value: resultado.total, color: '#00e5a0', bold: true },
                ].map((r, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: i < 4 ? '1px solid #222730' : 'none' }}>
                    <span style={{ fontSize: '12px', color: '#9ca3af' }}>{r.label}{r.nota ? <span style={{ fontSize: '10px', color: '#6b7280', marginLeft: '6px' }}>({r.nota})</span> : ''}</span>
                    <span style={{ fontSize: r.bold ? '14px' : '12px', fontWeight: r.bold ? '700' : '600', color: r.color }}>${r.value.toLocaleString('es-MX', { maximumFractionDigits: 0 })}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          {resultado && (
            <div style={{ fontSize: '11px', color: '#6b7280', padding: '8px 12px', background: 'rgba(245,158,11,0.05)', borderRadius: '6px', border: '1px solid rgba(245,158,11,0.15)' }}>
              ⚠️ Estimación aproximada. Las cuotas IMSS varían según el salario base de cotización, zona geográfica y tipo de contrato. Consulta a un contador para cifras exactas.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
}
